
const Annotation = {
  schema: {
    useText: { type: 'Boolean', label: 'Use Custom Text', defaultValue: false, animatable: false },
    text: { type: 'String', label: 'Custom Text', defaultValue: 'Annotation Text', animatable: false },
    open: { type: 'Boolean', label: 'Open by default', defaultValue: false, animatable: false },
    // Mis-spelled `limitVisibility`
    limitVisilibility: { type: 'Boolean', label: 'Limit Visibility', defaultValue: false, animatable: false },
    visibilityAngle: { type: 'Number', label: 'Visibility Angle', defaultValue: 180, step: 5, minValue: 10, maxValue: 360, animatable: false },
    directionMode: { label: 'Direction Mode', type: 'Options',
                labels: ['Manual', 'Away From Origin'],
                values: ['manual', 'awayFromOrigin'],
                defaultValue: 'manual', },
    directionAxis: { label: 'Direction', type: 'Options',
            labels: [ 'XAxis', 'YAxis', 'ZAxis' ],
            values: [ 'x', 'y', 'z' ],
            defaultValue: 'z' },
    directionTarget: { type: 'Node', label: 'Direction Target' },
  },

  update: function (operator, primitive, { node }) {
    Object.assign(primitive, operator);
    if (!operator.useText) primitive.text = node.name;
  },
};

export default { Annotation };



// WEBPACK FOOTER //
// ./src/operators/Annotation.js